import React from 'react'
import type { InlineInputProps, SelectProps } from '@ztechapps/webui.input'
import { TemplateSelectCreatable, TemplateSelectInlineInput } from '@ztechapps/webui.data-tools'
const templateCategory = 'paymentTerms_template'
const placeholder = 'Select a payment term.'

export const PaymentTermSelect = (props: SelectProps) => {
  return <TemplateSelectCreatable templateCategory={templateCategory} placeholder={placeholder} {...props} />
}

export const PaymentTermSelectInlineInput = (props: InlineInputProps) => {
  return (
    <TemplateSelectInlineInput selectComponent={PaymentTermSelect} templateCategory={templateCategory} {...props} />
  )
}
